import { MouseEvent, useState } from 'react';

import { cn } from '@/utils/cn';

import {
	greenStatus,
	redStatus,
	yellowStatus,
} from '../../constants/TrainingConstants';
import { ExpirationStatus } from '../../types/TrainingControlTypes';
import LightTooltip from './LightTooltip';

interface Props {
	status: ExpirationStatus | '-';
	upperCase?: boolean;
	className?: string;
}

const TableCellStatus = ({ status, upperCase, className }: Props) => {
	const [tooltipEnabled, setTooltipEnabled] = useState(false);

	const handleShouldShow = ({ currentTarget }: MouseEvent<Element>) => {
		if (currentTarget.scrollWidth > currentTarget.clientWidth) {
			setTooltipEnabled(true);
		}
	};

	let bgColor = '';
	if (greenStatus.includes(status)) {
		bgColor = 'bg-[#2E7D32]';
	} else if (redStatus.includes(status)) {
		bgColor = 'bg-[#F4503A]';
	} else if (yellowStatus.includes(status)) {
		bgColor = 'bg-[#DDB31D]';
	}

	return (
		<LightTooltip
			title={status}
			open={tooltipEnabled}
			onClose={() => setTooltipEnabled(false)}
			arrow
			placement="top-end"
		>
			{status !== '-' ? (
				<div
					onMouseEnter={handleShouldShow}
					className={cn(
						'ml-2 flex min-w-[3rem] text-nowrap rounded p-[5px] text-[11px] tracking-widest text-white',
						bgColor,
						className,
					)}
				>
					{upperCase ? status.toUpperCase() : status}
				</div>
			) : (
				<div className="w-28 text-center"></div>
			)}
		</LightTooltip>
	);
};

export default TableCellStatus;
